import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {apiClient} from '../../../../shared/api';
import {notifyError, notifySuccess} from '../../../../shared/notificationUtils';
import {HttpStatus} from '../../../../shared/constants/httpStatusCode';
import {DOWNLOAD_TEMPLATE, UPLOAD} from './constants';
import {
    downloadTemplateFailed,
    downloadTemplateSuccess,
    uploadFailed,
    uploadSuccess
} from './actions';
import {Message} from '../constants/message';

const MASTER_DATA_ENDPOINT = '/report-service/api/v2/master-data'

function* downloadTemplate({payload}) {
    const {apiPath} = payload
    const response = yield call(apiClient.download, `${MASTER_DATA_ENDPOINT}/${apiPath}-template`);
    if (response.error) {
        yield put(downloadTemplateFailed(response.detail));
        yield call(notifyError, 'An error has occurred while downloading the template');
    } else {
        yield put(downloadTemplateSuccess());
    }
}

function* upload({payload}) {
    const {apiPath, file} = payload
    const formData = new FormData();
    formData.append('file', file, file.name);
    const response = yield call(
        apiClient.post,
        `${MASTER_DATA_ENDPOINT}/${apiPath}`,
        formData,
        {'Content-Type': 'multipart/form-data'
    });
    if (response.error) {
        yield put(uploadFailed(response.detail));
        if (response.detail && response.detail.response) {
            switch (response.detail.response.status) {
                case HttpStatus.UnprocessableEntity:
                    yield call(notifyError, `${Message.UploadInvalidFile}: ${file.name}`);
                    return
                case HttpStatus.InternalServer:
                case HttpStatus.BadRequest:
                    yield call(notifyError, response.detail.response.data.detail);
                    return
                default:
                    yield call(notifyError, 'An error has occurred');
                    return
            }
        }
        yield call(notifyError, 'An error has occurred');

    } else {
        yield put(uploadSuccess(response.data));
        yield call(notifySuccess, 'Successfully uploaded');
    }
}

export function* watchDownloadTemplate(): any {
    yield takeEvery(DOWNLOAD_TEMPLATE, downloadTemplate);
}

export function* watchUpload(): any {
    yield takeEvery(UPLOAD, upload);
}

function* masterDataSaga(): any {
    yield all([
        fork(watchDownloadTemplate),
        fork(watchUpload)
    ]);
}

export default masterDataSaga;